import React from 'react';
import dateformat from 'dateformat';
import ViewForm, {ViewFormField} from './ViewForm';
import i18n from 'i18next';

export default ({action, fetching, status, type, iccid, dealer, date, permissions}) => permissions ? (
  <ViewForm
    formName='system'
    title={i18n.t('clients:System')}
    fetching={fetching}
    action={action}
    actionName={permissions.edit ? (i18n.t(status === 'ACTIVATED' ? 'clients:Deactivate' : 'clients:Activate')) : null}
  >
    <ViewFormField
      label={i18n.t('clients:Equipment type')}
      value={type}
      gridColumn={4}
    />
    <ViewFormField
      label={i18n.t('clients:Company')}
      value={dealer && dealer.name}
      gridColumn={4}
    />
    <ViewFormField
      label={i18n.t('clients:ICCID')}
      value={iccid}
      gridColumn={4}
    />
    <ViewFormField
      label={i18n.t('clients:Activation date')}
      value={dateformat(date, 'dd.mm.yyyy')}
      gridColumn={4}
    />
  </ViewForm>
) : null;
